export default __webpack_public_path__ + "static/media/moly_shadow.93f5eab4.svg";